import { render, staticRenderFns } from "./SmartMatchProfileCard.vue?vue&type=template&id=f707c84c&scoped=true"
import script from "./SmartMatchProfileCard.vue?vue&type=script&lang=ts"
export * from "./SmartMatchProfileCard.vue?vue&type=script&lang=ts"
import style0 from "./SmartMatchProfileCard.vue?vue&type=style&index=0&id=f707c84c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f707c84c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f707c84c')) {
      api.createRecord('f707c84c', component.options)
    } else {
      api.reload('f707c84c', component.options)
    }
    module.hot.accept("./SmartMatchProfileCard.vue?vue&type=template&id=f707c84c&scoped=true", function () {
      api.rerender('f707c84c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/smartMatch/SmartMatchProfileCard.vue"
export default component.exports